import { baseReducer as BaseReducer } from '../core/base-reducer';

import {
  V3_OPT_OUT_WITHOUT_FEEDBACK,
  V3_OPT_OUT_WITHOUT_FEEDBACK_FAILURE,
  V3_OPT_OUT_WITHOUT_FEEDBACK_SUCCESS,
} from './v3-opt-out.actions';

const initialState = {
  feedbackField: '',
  v3OptOutIsProcessing: false,
  v3OptOutErrorOnSubmit: false,
  redirectToV2: false,
};

const actionHandlerMap = {
  [V3_OPT_OUT_WITHOUT_FEEDBACK]: (state) => ({
    ...state,
    v3OptOutIsProcessing: true,
    v3OptOutErrorOnSubmit: false,
  }),
  [V3_OPT_OUT_WITHOUT_FEEDBACK_FAILURE]: (state) => ({
    ...state,
    v3OptOutIsProcessing: false,
    v3OptOutErrorOnSubmit: true,
  }),
  [V3_OPT_OUT_WITHOUT_FEEDBACK_SUCCESS]: (state, { redirectToV2 }) => {
    return {
      ...state,
      redirectToV2,
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './v3-opt-out.reducer.metadata';
